import { Button, Col, Row } from "react-bootstrap";
import { default as React, useState } from "react";
import DataTable from "containers/common/DataTable";
import EditableCell from "containers/common/EditableCell";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
    useReactTable,
    getCoreRowModel,
    getSortedRowModel,
    getPaginationRowModel,
    getFilteredRowModel,
    createColumnHelper,
} from "@tanstack/react-table";

function OwnerFileList({
    data,
    controlType,
    saveRecord,
    deleteFile,
    updateTableState,
    addRecord,
}) {
    const [sorting, setSorting] = useState([]);

    // --- TanStack Table Setup ---
    const tableData = data || [];
    const columnHelper = createColumnHelper();

    const columns = [
        columnHelper.accessor("search_file_name", {
            id: "search_file_name",
            header: "search_file_name",
            cell: EditableCell,
            size: 260,
        }),
        columnHelper.accessor("delete_file_name", {
            id: "delete_file_name",
            header: "",
            cell: row =>
                <Button type="button" size="sm" variant="danger" onClick={() => table.options.meta.handleDelete({ row })}>
                    Delete
                </Button>,
            size: 65,
        }),
    ];

    const table = useReactTable({
        data: tableData,
        columns: columns,
        state: { sorting },
        onSortingChange: setSorting,
        initialState: { pagination: { pageSize: 50, } },
        columnResizeMode: "onChange",
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        meta: {
            updateData: (rowIndex, columnId, value) => {
                updateTableState(rowIndex, columnId, value, 'files');
            },
            //this need fixing
            handleDelete: async ({ row }) => { deleteFile(row.original, 'files') }
        },
    });

    const tablesMap = {
        table: table
    };

    // --- Render Functions ---
    function renderList(data) {
        if (!data) {
            return null
        }
        else {
            return data.map((d, i) => {
                return (
                    <tr key={d.key || i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td className="p-0">
                            <div className="d-flex align-items-start py-1 px-2" style={{ gap: '0.35rem' }}>
                                <a
                                    href={d.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none flex-grow-1"
                                    style={{
                                        color: '#007bff',
                                        fontSize: '0.82rem',
                                        lineHeight: 1.2,
                                        minWidth: 0,
                                        overflowWrap: 'anywhere',
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    {d.key}
                                </a>
                                {typeof deleteFile === 'function' && (
                                    <Button
                                        type="button"
                                        variant="danger"
                                        size="sm"
                                        className="p-0 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '1.1rem',
                                            height: '1.1rem',
                                            minWidth: '1.1rem',
                                            fontSize: '0.72rem',
                                            lineHeight: 1,
                                            flexShrink: 0,
                                            marginTop: '1px'
                                        }}
                                        onClick={(e) => deleteFile(d, e)}
                                        title="Delete file"
                                    >
                                        ✕
                                    </Button>
                                )}
                            </div>
                        </td>
                    </tr>
                );
            }
            );
            // return [{}].concat(data).map(
            //     (d, i) =>
            //         i !== 0
            //             ?
            //             <ListGroup.Item key={i} header={d.key}>
            //                 {<div>
            //                     <a target="_blank" rel="noopener noreferrer" href={d.url} >{d.key}   </a>
            //                     <Badge size="sm" as="Button" onClick={(e) => deleteFile(d, e)} variant="danger">X</Badge>
            //                 </div>}
            //             </ListGroup.Item>
            //             : ""
            // );
        }
    }

    function renderComponent() {
        const activeTable = tablesMap[controlType] || tablesMap.table;

        return (
            <div className="files">
                {controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        <Button variant="secondary" size="sm" onClick={addRecord}>Add</Button>
                    </Col>
                </Row>}
                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                        {controlType === "table"
                            ? <DataTable tableInstance={activeTable} />
                            : renderList(data)}
                    </Col>
                </Row>
            </div>
        );
    }
    return (
        <div className="OwnerFileList">
            {renderComponent()}
        </div>
    );
}

export default OwnerFileList;